import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import characterClass from '~/pages/Dashboard/AnalyticsBox/reports/CharacterClass/characterClass.api';
import { requestStarted, requestFinished } from '~/stores/redux/common/loadingSlice';
import { handleThunkException } from '~/services/thunk.service';

export const fetchCharacterClassApi = createAsyncThunk(
    'dashboard/characterClass/fetchCharacterClassApi',
    async (navigate, { dispatch, rejectWithValue }) => {
        try {
            dispatch(requestStarted());
            const { data } = await characterClass.getAll();
            if (data) {
                dispatch(requestFinished());
                return data;
            }
        } catch (error) {
            handleThunkException(error, dispatch, navigate);

            throw rejectWithValue([]); //`throw` will dispatch RejectedAction. Ref: https://redux-toolkit.js.org/api/createAsyncThunk#promise-lifecycle-actions
        }
    },
);

export const characterClassSlice = createSlice({
    name: 'dashboard/characterClass',
    initialState: { rows: [] },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCharacterClassApi.fulfilled, (state, { payload }) => {
                state.rows = payload;
            })
            .addCase(fetchCharacterClassApi.rejected, () => {
                //do nothing so that state will remain intact and component will not re-render.
            });
    },
});
